





































import Vue from "vue";
import store, { BankStatementStore } from "../services/BankStatementStore";
import BankStatementApi from "../services/BankStatementApi";
import BankInViewApiSearchPage from "@/modules/bankExtract/components/BankInViewApiSearchPage.vue";
import BankOutViewApiSearchPage from "@/modules/bankExtract/components/BankOutViewApiSearchPage.vue";
import BankInView from "@/modules/bankInView/models/BankInView";
import BankOutView from "@/modules/bankOutView/models/BankOutView";
import eventBus from "@/services/eventBus";
import { t } from "@/plugins/i18n";

interface Data {
  store: BankStatementStore;
  inOut: boolean;
  isGenerating: boolean;
}

interface GenerateEvent {
  selectedItems: BankInView[] | BankOutView[];
  partnerID: number;
  isOverrideAmount: boolean;
}

interface Methods {
  generate(items: GenerateEvent): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    BankInViewApiSearchPage,
    BankOutViewApiSearchPage,
  },

  data: () => ({
    store,
    inOut: true,
    isGenerating: false,
  }),

  methods: {
    async generate(items) {
      if (this.isGenerating) return;
      if (!items.selectedItems || items.selectedItems.length < 1) return;

      try {
        this.isGenerating = true;
        await BankStatementApi.generateDocByInvoices(
          this.store.bankStatement.id,
          this.inOut,
          items.selectedItems
        );
        eventBus.$emit("success", t("BankStatement_BizonylatSikeresenLetrehozva"));

        await this.store.loadBankDocumentsByStatementId(
          this.store.bankStatement.id
        );
        this.$emit("created");
        this.$router.push(
          `/bank-statement/create/${this.store.bankStatement.id}/item`
        );
      } finally {
        this.isGenerating = false;
      }
    },
  },
});
